
const fontAwesome = require('../../../node_modules/font-awesome/css/font-awesome.min.css')